import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { CollectionAttributes } from 'src/app/models/advisor.interface';

@Component({
  selector: 'app-filter-modal',
  templateUrl: './filter-modal.component.html',
  styleUrls: ['./filter-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    MatChipsModule,
    MatDialogModule
  ]
})
export class FilterModalNewComponent {
  filterOptions: CollectionAttributes;
  selectedFilters: CollectionAttributes;
  filterTypes: string[];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      options: CollectionAttributes;
      currentFilters: CollectionAttributes;
    },
    private dialogRef: MatDialogRef<FilterModalNewComponent>
  ) {
    this.filterOptions = data.options;
    this.selectedFilters = { ...data.currentFilters };
    this.filterTypes = Object.keys(this.filterOptions);
  }
  onCancel(): void {
    this.dialogRef.close();
  }
  onApply(): void {
    // Remove empty arrays from selectedFilters
    for (const key in this.selectedFilters) {
      if (this.selectedFilters[key].length === 0) {
        delete this.selectedFilters[key];
      }
    }
    this.dialogRef.close(this.selectedFilters);
  }
  onClearAll(): void {
    this.selectedFilters = {
      state: [],
      year: []
    };
  }

  removeFilter(type: string, item: string): void {
    const idx = this.selectedFilters[type].indexOf(item);
    if (idx >= 0) {
      // Create a new array to trigger change detection
      this.selectedFilters[type] = [
        ...this.selectedFilters[type].slice(0, idx),
        ...this.selectedFilters[type].slice(idx + 1)
      ];
    }
  }
}
